import { Noto_Sans_TC as NotoSansTC } from 'next/font/google';

const notoSansTC = NotoSansTC({
	display: 'swap',
	subsets: ['latin'],
	variable: '--font-noto-sans-tc',
	weight: ['300', '400', '700'],
});

export default notoSansTC;
